import moment from 'moment';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
import isPostalCode from 'validator/lib/isPostalCode';

export function ValidateInput(input) {
  if(/[^a-zA-Z0-9&'()\-,./ ]+/.test(input)) {
    return false;
  }
  return true;
}

export function ValidateAddressInput(input) {
  if(/[^a-zA-Z0-9'.\-ÀàÂâÇçÉéÈèÊêËëÎîÏïÔôÙùÛûÜü ]+/.test(input)) {
    return false;
  }
  return true;
}

export function ValidateEmployerInput(input) {
  if(/[^a-zA-Z0-9&'()\-,./ÀàÂâÇçÉéÈèÊêËëÎîÏïÔôÙùÛûÜü ]+/.test(input)) {
    return false;
  }
  return true;
}

export function ValidateBirthdate(date) {
  if(date === "Invalid date" || moment(date).isAfter(moment())) {
    return false;
  }
  return true;
}

export function ValidateDate(date) {
  if(date === "Invalid date" || moment(date).isAfter(moment())) {
    return false;
  }
  return true;
}

export function ValidateAccountPassword(password) {
  if(/^[a-z0-9]+$/i.test(password)) {
    return true;
  }
  return false;
}

export function ValidateEmailAddress(email) {
  if(email === "" || isEmail(email)) {
    return true;
  }
  return false
}

export function ValidatePhoneNumber(phone) {
  if(isMobilePhone(phone, 'any')) {
    return true;
  }
  return false;
}

export function ValidatePhoneNumberOptional(phone) {
  if(phone.length === 0) {
    return true;
  } else if(isMobilePhone(phone, 'any')) {
    return true;
  }
  return false;
}

export function ValidateNoneZero(value) {
  if((value) === '0') {
    return false;
  } 
  return true;
}

export function ValidatePostalCode(postalCode) {
  if(isPostalCode(postalCode, 'CA')) {
    return true;
  }
  return false;
}

export function ValidateProvince(province) {
  return (province === "BC");
}

export function ValidateAddress(address) {
  let disallowedList = ["PO Box", "P O Box", "PO box", "PO BOX", "p o box", "P O box", "P O BOX", "po box", "General Delivery", "General delivery", "general delivery", "GENERAL DELIVERY", "general Delivery", "\\bGD\\b",];
  let regex = new RegExp(disallowedList.join('|'));

  return regex.test(address);    
}

export function ValidateMailingAddress(address) {
  let disallowedList = ["General Delivery", "General delivery", "general delivery", "GENERAL DELIVERY", "general Delivery", "\\bGD\\b",];
  let regex = new RegExp(disallowedList.join('|'));

  return regex.test(address);    
}

export function ValidateOfferCode(offerCode) {
  if((/^[a-z0-9]+$/i.test(offerCode) && offerCode.length === 6) || offerCode.length === 0) {
    return true;
  }
  return false;
}

export function IsEndOfCampaign() {
  debugger
  // PBI 420824: Add ASC codes to "apply now" links in Visa Online Application - Campaign end date:  Jan 4, 2024 
  const givenDate = new Date("2024,01,05");

  // Get the current date
  const currentDate = new Date();
  // Compare the two dates and check if the given date is in the future
  if (givenDate.getTime() <= currentDate.getTime()) {
   return true;
  } else {
    return false;
  }
}

export function IsEndOfLRCardsCampaign() {
  debugger
  // Product Backlog Item 430250: Add ASCs to "Apply Now" Links in Visa Online Application - Campaign end date:  March 28, 2024
  const givenDate = new Date("2024,03,29");

  // Get the current date
  const currentDate = new Date();
  // Compare the two dates and check if the given date is in the future
  if (givenDate.getTime() <= currentDate.getTime()) {
   return true;
  } else {
    return false;
  }
}

export function IsEndOfNVWOCardsCampaign() {
  debugger
  // Product Backlog Item 498682: Update Online Visa Application, ARC, and ABC with New Vancity Visa Welcome Offer Campaign ASCs - Campaign end date:  January 6, 2026
  const givenDate = new Date("2026,01,07");

  // Get the current date
  const currentDate = new Date();
  // Compare the two dates and check if the given date is in the future
  if (givenDate.getTime() <= currentDate.getTime()) {
   return true;
  } else {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/utils/Validation.js